import { useEffect, useState } from 'react';
import { currentUser } from 'js/utils/user';

/**
 * Hook to generate a hydration-safe download tracking function for the Single Work Page.
 * URLs are modified with tracking parameters only after the component has mounted.
 */
export function useDownloadTracking(
  downloadUrl: string,
  source: string,
): string {
  const [isMounted, setIsMounted] = useState(false);
  const [loadedTimestamp] = useState(() => new Date());

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // During SSR or initial render, return URL unchanged to avoid hydration mismatch
  if (!isMounted || !downloadUrl) {
    return downloadUrl;
  }

  // After mount, add tracking parameters
  const url = new URL(downloadUrl);

  let actualSource = source;
  if (source === 'news-feed') {
    actualSource = 'news';
  }

  if (!url.searchParams.has('ct')) {
    url.searchParams.set('ct', generateTrackingToken(loadedTimestamp));
  }

  if (!url.searchParams.has('s')) {
    url.searchParams.set('s', actualSource);
  }

  return url.toString();
}

function generateTrackingToken(loadedTimestamp: Date) {
  const tokenParams = [
    Math.round(loadedTimestamp.getTime() / 1000),
    Math.round(Date.now() / 1000),
  ];
  if (currentUser) {
    tokenParams.push(currentUser.id);
  }
  return window.btoa(tokenParams.join(','));
}
